<template>
    <div class="grid max-w-sm mx-auto py-16 gap-8 justify-items-center text-center" v-if="$route.query.success === 'true'">
      <img src="../assets/success-green.png" alt="Success" width="120" height="120" />
      <p class="grid gap-2">
        <span class="font-bold" v-if="$route.query.success">Payment Successful</span>
        <span class="text-2xl font-semibold" v-if="$route.query.amount">{{ $filters.formatMoney($route.query?.amount) }}</span>
      </p>
      <p v-if="$route.query.date">
        <span class="text-xs">Transaction Date:</span>
        <br />
        <span class="font-semibold" v-if="$route.query.date">{{ $filters.formatDate($route.query?.date, true) }}</span>
      </p>
      <p v-if="$route.query.id">
        <span class="text-xs">Transaction Reference Number:</span>
        <br />
        <span class="font-semibold">{{ $route.query?.id }}</span>
      </p>

      <router-link
              :to="{
                name: 'Dashboard',
              }"
            >
        <custom-button variant="primary">Done</custom-button>
      </router-link>
    </div>
    <div class="grid max-w-sm mx-auto py-16 gap-8 justify-items-center" v-else>
    <img src="../assets/mandate-failure.svg" alt="Failure" width="120" height="120" />
        <p class="text-center">
        <span class="font-bold">Payment Failed</span>
        <br />
        <br />If money has been deducted from your bank account, the same will be refunded to your bank account within 4-7 working days.
        </p>
        <router-link
              :to="{
                name: 'Dashboard',
              }"
            >
        <custom-button variant="primary">Try again</custom-button>
        </router-link>
    </div>
  </template>
  <script>
  import CustomButton from '../components/CustomButton.vue';

  export default {
    name: 'Processing-Fee-Result',
    components: {
      CustomButton,
    },
  };
  </script>
